export default (context) => {
  const timestamp = Date.now()
  return context.$axios.$get(
    `${context.$config.CDN_URL}translations/ru.json?t=${timestamp}`
  )
}
